<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    :label="i18n.global.t('pages.common.autocomplete.passenger')"
    itemName="name"
    :items="filteredByItems"
    :initial-item-id="initialItemId"
    :management-office="managementOffice"
    :operation-offices="operationOffices"
    :error-messages="errorMessages"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import { DRIVER_ROLE_ID } from "@/services/consts/account";
import { OPERATION_OFFICE_TYPE } from "@/services/consts";
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccountResponse from '@/types/responses/getAccount';
import getDepartmentResponse from '@/types/responses/getDepartment';
import getAccountsType from "@/types/requests/getAccounts";
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import i18n from '@/lang/i18n'

const props = defineProps<{
  modelValue: getAccountResponse | undefined;
  selectedDepartment: getDepartmentResponse | null
  initialItemId?: number;
  driverId: number | null;
  managementOffice?: getManagementOffice;
  operationOffices?: getOperationOffice[];
  errorMessages?: string[];
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', text: getAccountResponse | undefined): void
}>();

const items = ref<getAccountResponse[]>([]);

onMounted(() => {
  const params: getAccountsType = {
    officeable_type: OPERATION_OFFICE_TYPE,
    role_id: DRIVER_ROLE_ID
  }
  if(props.operationOffices && props.operationOffices.length > 0) {
    params.type_class = OPERATION_OFFICE_TYPE,
    params.officeable_id = props.operationOffices[0].id
  }
  Api()
    .autoCompleteAccounts(params)
    .then((data) => {
      items.value = data;
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const filteredByItems = computed(() => {
  if (!props.selectedDepartment && !props.driverId) {
    return items.value
  }

  let filteredItems: getAccountResponse[] = items.value
  if (props.selectedDepartment) {
    filteredItems = items.value.filter(item => item.department_id === props.selectedDepartment?.id)
  }

  if (props.driverId) {
    filteredItems = filteredItems.filter(item => item.driver_id !== props.driverId)
  }

  return filteredItems
})
</script>
